module.exports = __webpack_public_path__ + "static/center-for-u-00-hero-229cafa7a46813db12a6e979f65cf624.jpg";